import { ServiceHandler } from '../../../utils/api.utils';
import type {
  CatalogEntry,
  Integration,
  IntegrationTool,
  HealthCheckResult,
  CreateIntegrationPayload,
  UpdateIntegrationPayload,
  ValidateCredentialsPayload,
  ValidateCredentialsResult,
  ListGithubReposPayload,
  ListGithubReposResult,
} from '../types';

export const getIntegrationCatalog = ServiceHandler<unknown, CatalogEntry[]>({
  url: '/api/chat-agent/v1/integrations/catalog',
});

export const getIntegrations = ServiceHandler<
  unknown,
  { integrations: Integration[] }
>({
  url: '/api/chat-agent/v1/integrations',
});

export const getIntegration = ServiceHandler<unknown, Integration>({
  url: '/api/chat-agent/v1/integrations/:integrationId',
});

export const createIntegration = ServiceHandler<
  CreateIntegrationPayload,
  Integration
>({
  url: '/api/chat-agent/v1/integrations',
  method: 'POST',
});

export const updateIntegration = ServiceHandler<
  UpdateIntegrationPayload,
  Integration
>({
  url: '/api/chat-agent/v1/integrations/:integrationId',
  method: 'PATCH',
});

export const deleteIntegration = ServiceHandler<unknown, void>({
  url: '/api/chat-agent/v1/integrations/:integrationId',
  method: 'DELETE',
});

export const discoverIntegrationTools = ServiceHandler<
  unknown,
  { integration_id: string; tools: IntegrationTool[] }
>({
  url: '/api/chat-agent/v1/integrations/:integrationId/discover',
  method: 'POST',
});

export const updateIntegrationTool = ServiceHandler<
  { enabled: boolean },
  IntegrationTool
>({
  url: '/api/chat-agent/v1/integrations/:integrationId/tools/:toolId',
  method: 'PATCH',
});

export const checkIntegrationHealth = ServiceHandler<
  unknown,
  HealthCheckResult
>({
  url: '/api/chat-agent/v1/integrations/:integrationId/health',
});

export const validateCredentials = ServiceHandler<
  ValidateCredentialsPayload,
  ValidateCredentialsResult
>({
  url: '/api/chat-agent/v1/integrations/validate-credentials',
  method: 'POST',
});

export const listGithubRepos = ServiceHandler<
  ListGithubReposPayload,
  ListGithubReposResult
>({
  url: '/api/chat-agent/v1/integrations/github/repos',
  method: 'POST',
});
